import Page from './page';
import FacetFilters from '../components/product/facet-filters';
import AsyncConsumptionData from '../components/initial-order/async-consumption-data';

export default class InitialOrderCategoryPage extends Page {
  private readonly tireFacetFilters: FacetFilters;

  constructor(protected body: JQuery) {
    super(true);
    this.tireFacetFilters = new FacetFilters(body.find('.js-facetForm'), true);
  }

  init(): void {
    super.init();
    AsyncConsumptionData.initAll();
  }
}
